import { gql } from '@apollo/client'

export const GET_ME_NOTIFICATION_GROUPS = gql`
  query GET_ME_NOTIFICATION_GROUPS(
    $notificationType: NOTIFICATION_TYPE!
    $filters: NotificationsFilter
  ) {
    me {
      id
      notificationGroups(notificationType: $notificationType) {
        id
        notifications(filters: $filters) {
          id
          data
          status
        }
        slug
        status
        progress
        createdAt
      }
    }
  }
`
